import Reflux from 'reflux';

const IndexerOverviewActions = Reflux.createActions({
  list: { asyncResult: true },
});

export default IndexerOverviewActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/indexers/IndexerOverviewActions.jsx